module.exports = __webpack_public_path__ + "media/B_L18.be43c00d.mp3";